<template>
  <SACModal
    modalClass="cd-action-modal"
    :cardClass="`cdm-${actionModalView}`"
    :show="showActionModal"
    :close="() => toggleActionModal(false)"
  >
    <template
      v-if="actionModalView === 'upload-image'"
      #content
    >
      <UploadImage />
    </template>
    <template
      v-else-if="actionModalView === 'request-nameplate'"
      #content
    >
      <RequestNameplate />
    </template>
    <template
      v-else-if="actionModalView === 'breakdown-risk'"
      #content
    >
      <BreakdownRiskRecommendation />
    </template>
    <template
      v-else-if="actionModalView === 'performance-score' || actionModalView === 'performance-score-info'"
      #content
    >
      <PerformanceScoreModal v-if="actionModalView === 'performance-score'" />
      <PerformanceScoreInfo v-else />
    </template>
    <template
      v-else-if="actionModalView === 'contact-info'"
      #content
    >
      <ContactInfoForm />
    </template>
    <template
      v-else-if="actionModalView === 'cancel-subscription'"
      #content
    >
      <CancelSubscriptions />
    </template>
    <template
      v-else-if="actionModalView === 'activate-member'"
      #content
    >
      <ActivateMember />
    </template>
    <template
      v-else-if="actionModalView === 'deactivate-member'"
      #content
    >
      <DeactivateMember />
    </template>
    <template
      v-else-if="actionModalView === 'change-provider-plan'"
      #content
    >
      <ChangeProviderPlan />
    </template>
    <template
      v-else-if="actionModalView === 'welcome-email'"
      #content
    >
      <SendWelcomeEmail />
    </template>
    <template
      v-else-if="actionModalView === 'welcome-email-again'"
      #content
    >
      <SendWelcomeEmail />
    </template>
    <template
      v-else-if="actionModalView === 'merge-member'"
      #content
    >
      <MergeMember />
    </template>
    <template
      v-else-if="actionModalView === 'merge-member-form'"
      #content
    >
      <MergeMemberForm />
    </template>
    <template
      v-else-if="actionModalView === 'export-raw'"
      #content
    >
      <ExportRawForm />
    </template>
    <template
      v-else-if="actionModalView === 'edit-filter'"
      #content
    >
      <FilterForm
        :toggleModal="toggleActionModal"
        :isEdit="true"
      />
    </template>
    <template
      v-else-if="actionModalView === 'add-filter'"
      #content
    >
      <FilterForm
        :toggleModal="toggleActionModal"
        :isEdit="false"
      />
    </template>
    <template
      v-else-if="actionModalView === 'replace-filter'"
      #content
    >
      <ReplaceForm
        :selectedFilter="selectedFilter"
        :toggleModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'edit-sensor-details'"
      #content
    >
      <SensorDetailsForm
        :selectedSensor="selectedSensor"
        :toggleModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'edit-hub'"
      #content
    >
      <HubForm
        :customer="customer"
        :currentHub="currentHub"
        :selectedHvac="selectedHvac"
        :toggleModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'delete-warning'"
      #content
    >
      <DeleteSensorWarning
        :toggleModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'hub-address-update'"
      #content
    >
      <HubAddressUpdate
        :toggleModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'edit-questionnaire'"
      #content
    >
      <PropertyProfileForm
        :selectedProfile="propertyProfile"
        :toggleModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'edit-lastservice-date'"
      #content
    >
      <LastServiceModal
        :selectedProfile="propertyProfile"
        :toggleModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'replace-sensor'"
      #content
    >
      <ReplaceSensor
        :toggleModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'unverified-reasons'"
      #content
    >
      <UnverifiedReasons />
    </template>
    <template
      v-else-if="actionModalView === 'sync-hubspot'"
      #content
    >
      <SyncHubspot />
    </template>
    <template
      v-else-if="actionModalView === 'launch-visit'"
      #content
    >
      <LaunchVirtualVisit />
    </template>
    <template
      v-else-if="actionModalView === 'edit-visit'"
      #content
    >
      <EditVirtualVisit />
    </template>
    <template
      v-else-if="actionModalView === 'delete-visit'"
      #content
    >
      <DeleteVirtualVisit />
    </template>
    <template
      v-else-if="actionModalView === 'example-virtual-visit'"
      #content
    >
      <ExampleVirtualVisit />
    </template>
    <template
      v-else-if="actionModalView === 'send-virtual-visit'"
      #content
    >
      <SendVirtualEmail />
    </template>
    <template
      v-else-if="actionModalView === 'delete-filter'"
      #content
    >
      <DeleteConfirm />
    </template>
    <template
      v-else-if="actionModalView === 'few-min'"
      #content
    >
      <TakeAFewCheckLater />
    </template>
    <template
      v-else-if="actionModalView === 'edit-address'"
      #content
    >
      <EditAddressForm
        :memberAddress="memberAddress"
      />
    </template>
    <template
      v-else-if="actionModalView === 'adjust-rewards'"
      #content
    >
      <AdjustRewards
        :customer="customer"
        :confirmReason="() => toggleActionModal(true, 'confirm-transaction-reason')"
        :close="() => toggleActionModal(false)"
      />
    </template>
    <template
      v-else-if="actionModalView === 'confirm-transaction-reason'"
      #content
    >
      <ConfirmTransactionReason
        :close="() => toggleActionModal(false)"
        :goBack="() => toggleActionModal(true, 'adjust-rewards')"
      />
    </template>
    <template
      v-else-if="actionModalView === 'change-partner'"
      #content
    >
      <ChangePartner />
    </template>
  </SACModal>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import SACModal from '@shared/components/sac/SACModal.vue';
import RequestNameplate from '@shared/components/customerDetail/modal/RequestNameplate.vue';
import EditAddressForm from '@shared/components/customerDetail/modal/EditAddressForm.vue';
import BreakdownRiskRecommendation
  from '@shared/components/customerDetail/modal/BreakdownRiskRecommendation.vue';
import PerformanceScoreModal
  from '@shared/components/customerDetail/modal/PerformanceScoreModal.vue';
import PerformanceScoreInfo
  from '@shared/components/customerDetail/modal/PerformanceScoreInfo.vue';
import HubAddressUpdate from './editForms/HubAddressUpdate.vue';
import UploadImage from './modal/UploadImage.vue';
import ContactInfoForm from './modal/ContactInfoForm.vue';
import ReplaceSensor from './modal/ReplaceSensor.vue';
import CancelSubscriptions from './modal/CancelSubscriptions.vue';
import SendWelcomeEmail from './modal/SendWelcomeEmail.vue';
import MergeMember from './modal/MergeMember.vue';
import MergeMemberForm from './modal/MergeMemberForm.vue';
import ChangeProviderPlan from './modal/ChangeProviderPlan.vue';
import UnverifiedReasons from './modal/UnverifiedReasons.vue';
import ExportRawForm from './ExportRawForm.vue';
import FilterForm from './editForms/FilterForm.vue';
import DeleteConfirm from './editForms/DeleteConfirm.vue';
import ReplaceForm from './editForms/ReplaceForm.vue';
import HubForm from './editForms/HubForm.vue';
import PropertyProfileForm from './editForms/PropertyProfileForm.vue';
import SensorDetailsForm from './editForms/SensorDetailsForm.vue';
import SyncHubspot from './modal/SyncHubspot.vue';
import ActivateMember from './modal/ActivateMember.vue';
import DeactivateMember from './modal/DeactivateMember.vue';
import LaunchVirtualVisit from './modal/LaunchVirtualVisit.vue';
import EditVirtualVisit from './modal/EditVirtualVisit.vue';
import DeleteVirtualVisit from './modal/DeleteVirtualVisit.vue';
import ExampleVirtualVisit from './modal/ExampleVirtualVisit.vue';
import SendVirtualEmail from './modal/SendVirtualEmail.vue';
import TakeAFewCheckLater from './modal/TakeAFewCheckLater.vue';
import DeleteSensorWarning from './editForms/DeleteSensorWarning.vue';
import AdjustRewards from './modal/AdjustRewards.vue';
import ConfirmTransactionReason from './modal/ConfirmTransactionReason.vue';
import ChangePartner from './modal/ChangePartner.vue';
import LastServiceModal from './editForms/LastServiceModal.vue';

export default {
  name: 'ActionModal',
  components: {
    BreakdownRiskRecommendation,
    PerformanceScoreModal,
    PerformanceScoreInfo,
    EditAddressForm,
    RequestNameplate,
    SACModal,
    UploadImage,
    ContactInfoForm,
    ExportRawForm,
    CancelSubscriptions,
    SendWelcomeEmail,
    MergeMember,
    MergeMemberForm,
    FilterForm,
    ReplaceForm,
    HubForm,
    PropertyProfileForm,
    HubAddressUpdate,
    SensorDetailsForm,
    ReplaceSensor,
    ChangeProviderPlan,
    UnverifiedReasons,
    SyncHubspot,
    ActivateMember,
    DeactivateMember,
    LaunchVirtualVisit,
    EditVirtualVisit,
    DeleteVirtualVisit,
    ExampleVirtualVisit,
    SendVirtualEmail,
    DeleteConfirm,
    TakeAFewCheckLater,
    DeleteSensorWarning,
    AdjustRewards,
    ConfirmTransactionReason,
    ChangePartner,
    LastServiceModal,
  },
  mixins: [customerDetailMixin],
};
</script>

<style lang="scss">
.cd-action-modal {
  .cdm-new-order {
    width: 1000px;
    height: 800px;
    max-height: calc(100vh - 70px);

    .ac-body-container {
      overflow-y: auto;
    }

    .ac-error-container {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .error-text {
      font-size: 0.875rem;
      font-weight: 500;
      color: $TOMATO100;
    }
  }
  .cdm-upload-image {
    width: 600px;
    height: 500px;
    max-height: calc(100vh - 70px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-performance-score-info {
    width: 440px;
    height: 80vh;
    max-height: calc(100vh - 70px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-contact-info, .cdm-breakdown-risk, .cdm-performance-score {
    width: 600px;
    max-height: calc(100vh - 70px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-edit-address {
    width: 600px;
    height: 550px;
    max-height: calc(100vh - 70px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-adjust-rewards {
    width: 500px;
    height: 80vh;
    max-height: 1000px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-confirm-transaction-reason {
    width: 416px;
    height: 296px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-welcome-email, .cdm-welcome-email-again {
    width: 500px;
  }
  .cdm-change-provider-plan {
    width: 480px;
  }
  .cdm-change-partner {
    width: 480px;
  }
  .cdm-edit-hub {
    height: 400px;
    width: 600px;
  }
  .cdm-delete-warning {
    height: 275px;
    width: 595px;
  }
  .cdm-cancel-subscription, .cdm-request-nameplate {
    width: 500px;
    height: 270px;
    max-height: calc(100vh - 70px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-activate-member {
    width: 600px;
    height: 400px;
    max-height: calc(100vh - 70px);
  }
  .cdm-merge-member, .cdm-merge-member-form {
    width: 500px;
  }
  .cdm-delete-filter {
    width: 500px;
    height: 230px;
  }
  .cdm-deactivate-member {
    width: 680px;
    height: 590px;
    max-height: calc(100vh - 70px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-export-raw {
    width: 600px;
    height: 500px;
    max-height: calc(100vh - 70px);
    .ac-body-container {
      overflow-y: auto;
      .ac-error-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .error-text {
        font-size: 0.875rem;
        font-weight: 500;
        color: $TOMATO100;
      }
    }
  }
  .cdm-edit-hvac {
    width: 750px;
    height: 600px;
    .ac-body-container {
       overflow-y: auto;
    }
  }
  .cdm-edit-filter, .cdm-add-filter {
    width: 700px;
    max-height: 750px;
    height: 70vh;
    .ac-body-container {
      overflow-y: auto;
      scrollbar-width: none;
    }
  }

  .cdm-edit-questionnaire {
    width: 600px;
    height: 500px;
    .ac-body-container {
      overflow-y: auto;
    }
  }

  .cdm-edit-sensor-details {
    width: 400px;
    height: 500px;
    .ac-body-container {
      overflow-y: auto;
      .ac-body-sub-container {
        margin-bottom: 12px;
      }
      .ac-input-container {
        margin-right: 0;
      }
    }
  }
  .cdm-replace-sensor {
    width: 600px;
    height: 300px;
    .ac-body-container {
      overflow-y: auto;
      .ac-body-sub-container {
        margin-bottom: 12px;
      }
      .ac-input-container {
        margin-right: 0;
      }
    }
  }

  .cdm-unverified-reasons{
    width: 590px;
    height: 470px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-launch-visit {
    width: 934px;
    height: 446px;
  }
  .cdm-edit-visit {
    width: 832px;
    height: 644px;
  }
  .cdm-delete-visit {
    width: 680px;
    height: 240px;
  }
  .cdm-example-virtual-visit {
    min-width: 700px;
    min-height: 400px;
    width: 80vw;
    height: 90vh;
  }
  .cdm-send-virtual-visit {
    width: 600px;
    max-height: calc(100vh - 70px);
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .cdm-few-min {
    width: 525px;
    height: 250px;
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;
    .ac-header-container {
      padding: 29px 24px 19px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $NBLUE10;
      .ac-header {
        font-size: 1.25rem;
        font-weight: 500;
      }
      .ac-close-button {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background-color: $NBLUE10;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background-color: $NBLUE20;
        }
        .ac-close {
          width: 10px;
          height: 10px;
        }
      }
    }
    .ac-body-container {
      flex: 1;
      padding: 20px;
      display: flex;
      flex-direction: column;
      .ac-body-header {
        font-size: 1.125rem;
        text-align: center;
      }
      .order-charge-container {
        border-top: 2px dashed $N10;
        margin-top: 16px;
      }
      .ac-input-container {
        flex: 1;
        margin-right: 12px;
        .match-background {
          background: $NBLUE5;
          border-radius: 3px;
          border: unset;
        }
        &:not(:last-child) {
          margin-bottom: 18px;
        }
        .ac-input-header {
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: 3px;
        }
        .i-checkbox {
          position: relative;
          cursor: pointer;
          height: 30px;
          width: 30px;
          background-color: $NBLUE10;
          display: grid;
          &:hover {
            background-color: $NBLUE20;
          }
          &.c-active {
            background-color: $NBLUE100;
          }
          .i-visible-checkbox {
            position: absolute;
            top: 0;
            left: 0;
            &.active {
              left: 10px;
              top: 4px;
              width: 9px;
              height: 17px;
              border: solid $WHITE;
              border-width: 0 3px 3px 0;
              justify-self: center;
              align-self: center;
              transform: rotate(45deg);
            }
          }
        }
        .ac-input-number {
          height: 48px;
          border-radius: 33px;
          width: 80px;
          padding: 0 20px;
          background-color: $NBLUE20;
        }
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input {
          height: 48px;
          width: 100%;
          background-color: $NBLUE5;
          border: none;
          border-radius: 2px;
          padding: 0 10px;
        }
        textarea {
          width: 100%;
          height: 143px;
          padding: 8px 10px;
          border-radius: 2px;
          background-color: $NBLUE5;
          border: none;
          resize: none;
        }
        .ac-input-footer-container {
          display: flex;
          .ac-text-count {
            flex: 1;
            text-align: right;
            font-size: 0.75rem;
            font-weight: 500;
            color: $N60;
          }
        }
        .ac-input-error {
          color: $TOMATO100;
          font-size: 0.875rem;
        }
      }
      .ac-dropdown-container {
        margin-top: 24px;
      }
      .ac-body-sub-container {
        display: flex;
        justify-content: space-between;
      }
      .ac-body-tri-container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 2rem;
      }
      .ac-cancel-warning {
        font-weight: 500;
        color: $N90;
        text-align: center;
        padding: 0 30px;
      }
      .ac-row-container {
        display: flex;
        width: 100%;
        margin-bottom: 12px;
        .ac-input-container {
          margin-bottom: 0;
          &:not(:last-child) {
            margin-right: 12px;
          }
        }
      }
      .radio-timezone{
        display:flex;
        justify-content: flex-start;
        .radio{
          margin-left:20px;
          color: $BLACK;
          font-weight: 600;
        }
      }
      .ac-input {
        padding-left: 10px;
        padding-right: 10px;
        width: 100%;
        background-color: #F6F8FF;
        height: 48px;
        display: flex;
        align-items: center;
      }
      .range-container {
         position: relative;
         .date-container {
           display: flex;
           align-items: center;
           gap: 5px;
           .date {
             display: flex;
             align-items: center;
             padding-left: 9px;
             padding-right: 9px;
             width: 200px;
             height: 40px;
             border-radius: 6px;
             background-color: $NBLUE5;
             font-size: 12.64px;
             .calendar {
               width: 15px;
               height: 15px;
             }
             span {
               width: 100%;
               text-align: center;
             }
           }
         }
         .divider{
           color: $BLACK;
           font-weight: 600;
           background-color: $WHITE;
           display: flex;
           align-items: center;
           margin-right: 10px;
           margin-left: 10px;
         }
         .date-picker-start {
           position: absolute;
           width: 100%;
           left: 0;
           bottom: 0;
           input {
             opacity: 0;
           }
         }
         .date-picker-end {
           position: absolute;
           width: 100%;
           right: 1px;
           bottom: 0;
           input {
             opacity: 0;
           }
         }
       }
      .upload-image-container {
        background: $N10;
        display: grid;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        height: 100%;
        .dropbox-form {
          height: 100%;
          .dropbox-container {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
            cursor: pointer;
            position: relative;
            .db-input {
              opacity: 0;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              width: 100%;
              cursor: pointer;
            }
            .db-header {
              display: flex;
              flex-direction: column;
              font-size: 1.25rem;
              font-weight: 500;
              text-align: center;
            }
          }
        }
        .image-preview {
          height: 100%;
          width: 100%;
          object-fit: cover;
          overflow: hidden;
        }
      }

      .ac-body-order-detail {
        display: grid;
        gap: 1rem;

        .od-top-container {
          .od-header {
            background: $SUNSET70;
            padding: 10px;
            font-weight: 700;
            text-transform: uppercase;
            border-radius: 6px;
            color: $N90;
          }

          .od-info {
            padding: 10px;
            display: grid;

            .od-info-item {
              font-size: 14px;
              color: $N90;
              display: grid;
              gap: 10px;
              margin-top: 10px;
            }

            .od-info-customer {
              font-size: 14px;
              color: $N100;
              font-weight: 500;
              border-bottom: 1px solid $N10;

              .od-info-sub-customer {
                display: grid;
                grid-auto-flow: column;
                justify-content: space-between;

                .od-f-icon {
                  padding: 0 9px;
                  background: $N100;
                  border-radius: 50%;
                  font-weight: 700;
                  font-size: 15px;
                  color: $WHITE;
                  margin-left: 10px;
                  cursor: pointer;
                  position: relative;

                  &:hover {
                    .od-filters-info {
                      display: block;
                    }
                  }

                  .od-filters-info {
                    display: none;
                    position: absolute;
                    background-color: $NBLUE10;
                    padding: 7px 16px 7px 16px;
                    box-shadow: 0 3px 6px rgba(9, 15, 32, 0.07);
                    border-radius: 6px;
                    white-space: nowrap;
                    right: 0;
                    color: $BLACK;

                    &:after {
                      content: '';
                      position: absolute;
                      top: 0;
                      right: 3px;
                      width: 0;
                      border: 8px solid transparent;
                      border-bottom-color: $NBLUE10;
                      border-top: 0;
                      margin-top: -8px;
                    }

                    .od-filter-label {
                      width: 100%;
                      font-size: 0.875rem;
                      color: $BLACK;
                      font-weight: 400;
                      border-top: 1px solid $N20;
                    }
                  }
                }
              }
            }
          }
        }

        .od-total-container {
          background: $N5;
          font-size: 13px;
          padding: 8px 10px;
          font-weight: 700;
          text-transform: uppercase;
          border-radius: 6px;
          color: $N90;
          display: grid;
          grid-auto-flow: column;
          justify-content: space-between;
        }
      }

      .ac-shipment-detail {
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .ac-address-container {
          flex: 1;

          &:last-child {
            margin-left: 12px;
          }
        }

        .ac-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: $N5;
          border-radius: 6px;
          color: $N90;
          padding: 8px 10px;

          .ac-edit-btn {
            background-color: $N50;
            padding: 0 8px;
            color: $WHITE;
            font-size: 0.75rem;
            border-radius: 4px;
          }
        }

        .ac-body {
          padding: 4px 10px;
        }
      }
    }
    .tooltip-container {
      position: relative;
      .tooltip-img {
        height: 20px;
        width: auto;
        cursor: pointer;
      }
      .tooltip-text {
        font-size: 14px;
        background-color: $N90;
        color: $WHITE;
        padding: 10px;
        border-radius: 3px;
        opacity: 0.9;
        display: none;
        position: absolute;
        z-index: 10;
        white-space: nowrap;
        left: 25px;
        top: -7px;
      }
      &:hover {
        .tooltip-text {
          display: block;
        }
      }
    }
  }
  .ac-delete-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-top: 1px solid $NBLUE10;
    gap: 10px;
    .button-loader {
      width: 30px;
      height: 30px;
    }
    button:not(:last-child) {
      margin-right: 12px;
    }
    .ac-form-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE100;
      color: $WHITE;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE90;
      }
      &:disabled {
        background-color: $N50;
        pointer-events: none;
      }
      &:not(:last-child) {
        margin-left: 11px;
        background-color: $NBLUE10;
        color: $N50;
        &:hover {
          background-color: $NBLUE20;
        }
      }
      &.grey {
        background-color: $N90;
        color: $WHITE;
      }
    }
  }
  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid $NBLUE10;
    button:not(:last-child) {
      margin-right: 12px;
    }
    .ac-form-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE100;
      color: $WHITE;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE90;
      }
      &:disabled {
        background-color: $N50;
        pointer-events: none;
        cursor: none;
      };
      &:not(:last-child) {
        margin-left: 11px;
        background-color: $NBLUE10;
        color: $N50;
        &:hover {
          background-color: $NBLUE20;
        }
      }
      &.grey {
        background-color: $N90;
        color: $WHITE;
      }
      &.redbg {
        background-color: $TOMATO100 !important;
        color: $WHITE !important;
      }
    }
    .ac-form-cancel-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $TOMATO100;
      color: $WHITE;
      font-weight: 600;
      &:hover {
        background-color: $TOMATO200;
      }
    }
    .ac-form-cancel-button-two {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      border: 2px solid $NBLUE90;
      color: $NBLUE90;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE90;
      }
      &:not(:last-child) {
        margin-left: 11px;
        color: $NBLUE90;
        &:hover {
          background-color: $NBLUE20;
        }
      }
      &.grey {
        color: $NBLUE90;
      }
    }
  }
  .ac-overlay {
    border-radius: 12px;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
